export const ACCESS_TOKEN =
  "pk.eyJ1IjoiZHlsYW5ycCIsImEiOiJja2JsdzBqMHoxY3RwMnpxdmtqZGVqZ2g2In0.fQjdYivRvSmbR09Ygn0WdA";

export const MAP_STYLE = "mapbox://styles/mapbox/light-v10";

export const HELSINKI_CENTER_COORDINATES = [24.9144, 60.1699];

export const HELSINKI_CENTER_MOBILE_COORDINATES = [24.9484, 60.1599];

export const STORE_SWIPER_OPTIONS = {
  centeredSlides: true,
  loop: true,
  slidesPerView: 1.2,
  spaceBetween: 10,
  breakpoints: {
    550: {
      slidesPerView: 2,
      spaceBetween: 20
    }
  }
};

export const PRODUCT_MAP_CLUSTER_LAYER = {
  id: "product_clusters",
  type: "circle",
  source: "product_data_source",
  filter: ["has", "point_count"],
  paint: {
    "circle-color": "#ffa09d",
    "circle-radius": ["step", ["get", "point_count"], 10, 100, 20, 500, 50],
    "circle-stroke-width": 1,
    "circle-stroke-color": "#fff"
  }
};

export const PRODUCT_MAP_COUNT_LAYER = {
  id: "product_clusters_count",
  type: "symbol",
  source: "product_data_source",
  filter: ["has", "point_count"],
  layout: {
    "text-field": "{point_count_abbreviated}",
    "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
    "text-size": 12
  }
};

export const PRODUCT_MAP_POINT_LAYER = {
  id: "product_points",
  type: "circle",
  source: "product_data_source",
  filter: ["!", ["has", "point_count"]],
  paint: {
    "circle-color": "#ffa09d",
    "circle-radius": 20,
    "circle-stroke-width": 1,
    "circle-stroke-color": "#fff"
  }

  // type: "symbol",
  // source: "product_data_source",
  // filter: ["!", ["has", "point_count"]],
  // layout: {
  //   "icon-image": ["get", "markerSource"],
  //   "icon-anchor": "center",
  //   "icon-size": 0.1,
  //   "icon-keep-upright": true
  // },
  // paint: {
  //   "icon-halo-width": 0.1
  // }
};

export const PRODUCT_MAP_SOURCE_CONFIG = {
  type: "geojson",
  cluster: true,
  clusterRadius: 20,
  clusterMaxZoom: 20
};
